// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FirmwareDocuments_wrapper__3O9Ye","table-head":"FirmwareDocuments_table-head__2-rM9"};